module.exports = __webpack_public_path__ + "img/func.c1ba1a17.png";